import { render, staticRenderFns } from "./clientManage.vue?vue&type=template&id=4e978f24&scoped=true&"
import script from "./clientManage.vue?vue&type=script&lang=js&"
export * from "./clientManage.vue?vue&type=script&lang=js&"
import style0 from "./clientManage.vue?vue&type=style&index=0&id=4e978f24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e978f24",
  null
  
)

export default component.exports